import { createRouter, createWebHistory } from 'vue-router'
import { h } from 'vue'
import Login from "@/views/login/login.vue"
import NotFound from "@/components/error/404.vue"
import Forbidden from "@/components/error/403.vue"
import AdminLayout from "@/components/admin-layout/admin-layout.vue"
import AdminDashboard from "@/views/admin/dashboard/dashboard.vue"
import AdminBooks from "@/views/admin/books/books.vue"
import AdminAuthors from "@/views/admin/authors/authors.vue"
import AdminTranslators from "@/views/admin/translators/translators.vue"
import AdminCategories from "@/views/admin/categories/categories.vue"
import AdminBookSuggests from "@/views/admin/book-suggests/book-suggests.vue"
import AdminApprovals from "@/views/admin/approvals/approvals.vue"

const Authority = {
  GUEST: "ROLE_GUEST",
  ADMIN: 'ROLE_ADMIN',
  STAFF: 'ROLE_STAFF',
}

const router = createRouter({
  history: createWebHistory("/"),
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        isLogin: false,
        title: 'Đăng Nhập',
        authorities: [Authority.GUEST]
      },
    },
    {
      path: '/management',
      component: AdminLayout,
      redirect: '/management/books',
      meta: {
        isLogin: true,
        authorities: [Authority.ADMIN, Authority.STAFF]
      },
      children: [
        {
          path: 'dashboard',
          name: 'AdminDashboard',
          component: AdminDashboard,
          meta: {
            isLogin: true,
            title: 'Tổng quan hệ thống',
            authorities: [Authority.ADMIN, Authority.STAFF]
          }
        },
        {
          path: 'books',
          name: 'AdminBooks',
          component: AdminBooks,
          meta: {
            isLogin: true,
            title: 'Kho sách',
            authorities: [Authority.ADMIN, Authority.STAFF]
          }
        },
        {
          path: 'authors',
          name: 'AdminAuthors',
          component: AdminAuthors,
          meta: {
            isLogin: true,
            title: 'Quản lý tác giả',
            authorities: [Authority.ADMIN, Authority.STAFF]
          }
        },
        {
          path: 'translators',
          name: 'AdminTranslators',
          component: AdminTranslators,
          meta: {
            isLogin: true,
            title: 'Quản lý dịch giả',
            authorities: [Authority.ADMIN, Authority.STAFF]
          }
        },
        {
          path: 'categories',
          name: 'AdminCategories',
          component: AdminCategories,
          meta: {
            isLogin: true,
            title: 'Quản lý thể loại',
            authorities: [Authority.ADMIN, Authority.STAFF]
          }
        },
        {
          path: 'book-suggests',
          name: 'AdminBookSuggests',
          component: AdminBookSuggests,
          meta: {
            isLogin: true,
            title: 'Đề xuất sách',
            authorities: [Authority.ADMIN, Authority.STAFF]
          }
        },
        {
          path: 'approvals',
          name: 'AdminApprovals',
          component: AdminApprovals,
          meta: {
            isLogin: true,
            title: 'Phê duyệt yêu cầu',
            authorities: [Authority.ADMIN, Authority.STAFF]
          }
        }
      ]
    },
    {
      path: '/',
      redirect: '/management/books',
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'NotFound',
      component: NotFound,
      meta: {
        error: true,
        title: 'Trang không tồn tại',
        authorities: []
      },
    },
    {
      path: '/forbidden',
      name: 'Forbidden',
      component: Forbidden,
      meta: {
        error: true,
        title: "Không có quyền truy cập trang",
        authorities: []
      },
    },
  ]
})


router.beforeEach((to, from, next) => {
  const isAuthenticated = checkAuthentication();
  const authority = getAuthority()

  const checkAuthority = authority.some(element => to.meta.authorities.includes(element)) || to.meta.authorities.length === 0;

  if (to.meta.error) {
    document.title = to.meta.title || 'Lối đọc';
    return next();
  }

  if (to.meta.isLogin) {
    if (isAuthenticated) {
      if (checkAuthority) {
        next();
      } else {
        next("/forbidden")
      }
    } else {
      next('/login');
    }
  } else {
    // Chỉ điều hướng về trang chủ '/' nếu người dùng đã đăng nhập cố truy cập vào các trang dành riêng cho Guest (như login, register)
    const isGuestOnlyRoute = to.path === '/login' || to.path === '/register';
    if (isGuestOnlyRoute && isAuthenticated) {
      next("/");
    } else {
      next();
    }
  }
  document.title = to.meta.title || 'Lối đọc';
});

function checkAuthentication() {
  return localStorage.getItem("token") != null;
}

function getAuthority() {
  if (checkAuthentication()) {
    try {
      const rawAcc = localStorage.getItem('current-account');
      if (!rawAcc || rawAcc === 'undefined') return Array.from(Authority.GUEST);
      const acc = JSON.parse(rawAcc);
      if (!acc || !acc.authority) return Array.from(Authority.GUEST);
      if (Array.isArray(acc.authority)) {
        return acc.authority;
      }
      if (typeof acc.authority === 'string') {
        try {
          const parsed = JSON.parse(acc.authority);
          return Array.isArray(parsed) ? parsed : [acc.authority];
        } catch (e) {
          return [acc.authority];
        }
      }
      return Array.from(Authority.GUEST);
    } catch (e) {
      console.error("Error parsing authority:", e);
      return Array.from(Authority.GUEST);
    }
  } else {
    return Array.from(Authority.GUEST);
  }
}

export default router

